import styled, { css } from "styled-components";

export const avatarStyle = css`
  display: flex;
  width: 34px;
  height: 34px;
  overflow: hidden;

  background-color: #eaecf0;
  border-radius: 50%;
  border: 2px solid white;

  font-family: "Rubik", sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: black;
`;

export const Avatar = styled.div`
  ${avatarStyle}

  > img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;
